var _path, _path2, _path3, _line, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServerErrorState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 48,
    viewBox: "0 0 59 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7392 7.34413C31.2117 7.35117 30.692 7.47722 30.2162 7.71355C29.8339 7.89339 29.5102 8.18467 29.2844 8.55199L8.34393 44.4179C8.23856 44.5918 8.19257 44.7976 8.21334 45.002C8.22182 45.2072 8.29852 45.4031 8.43038 45.5564C8.61086 45.8143 8.86448 46.0072 9.15574 46.108C9.5011 46.2691 9.87542 46.3523 10.254 46.3521L53.6474 46.1161C54.023 46.1101 54.3943 46.0328 54.743 45.8879C55.0297 45.7635 55.2783 45.5605 55.4622 45.3006C55.5924 45.1459 55.6669 44.9492 55.6732 44.7439C55.6917 44.5392 55.6435 44.334 55.5363 44.1612L34.2069 8.52522C33.9772 8.16037 33.6503 7.87263 33.2661 7.69696C32.7877 7.46582 32.2667 7.34543 31.7392 7.34413Z",
    fill: "#CCE4F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7392 7.34413C31.2117 7.35117 30.692 7.47722 30.2162 7.71355C29.8339 7.89339 29.5102 8.18467 29.2844 8.55199L8.34393 44.4179C8.23856 44.5918 8.19257 44.7976 8.21334 45.002C8.22182 45.2072 8.29852 45.4031 8.43038 45.5564C8.61086 45.8143 8.86448 46.0072 9.15574 46.108C9.5011 46.2691 9.87542 46.3523 10.254 46.3521L53.6474 46.1161C54.023 46.1101 54.3943 46.0328 54.743 45.8879C55.0297 45.7635 55.2783 45.5605 55.4622 45.3006C55.5924 45.1459 55.6669 44.9492 55.6732 44.7439C55.6917 44.5392 55.6435 44.334 55.5363 44.1612L34.2069 8.52522C33.9772 8.16037 33.6503 7.87263 33.2661 7.69696C32.7877 7.46582 32.2667 7.34543 31.7392 7.34413Z",
    fill: "#CCE4F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8882 7.82695C27.5511 5.15191 31.4443 5.15191 33.1072 7.82695L53.0089 39.8427C54.7687 42.6738 52.7329 46.3365 49.3994 46.3365H9.59601C6.26254 46.3365 4.22669 42.6738 5.98653 39.8427L25.8882 7.82695Z",
    stroke: "#1370BC",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 29.6167,
    y1: 15.6767,
    x2: 29.6167,
    y2: 32.0099,
    stroke: "#1370BC",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.4945,
    cy: 37.664,
    r: 1.88459,
    fill: "#1370BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerErrorState);
export default __webpack_public_path__ + "static/media/serverErrorState.c70c2e18fdd248b2f1a36cb25386b4b1.svg";
export { ForwardRef as ReactComponent };